import { render, staticRenderFns } from "./shop-default.vue?vue&type=template&id=1108b5ae&scoped=true"
import script from "./shop-default.vue?vue&type=script&lang=js"
export * from "./shop-default.vue?vue&type=script&lang=js"
import style0 from "./shop-default.vue?vue&type=style&index=0&id=1108b5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1108b5ae",
  null
  
)

export default component.exports